export enum MemberAnswerOption {
  yes = 'YES',
  no = 'NO',
  na = 'NA',
}